import React, { useState } from 'react';

import { FormikHelpers } from 'formik';

import CountryCodeOptions from './components/CountryCodeOptions';
import { Container, InputArea, Arrow, Code, Flag } from './styles';

export interface CountryCode {
  id: string;
  name: string;
  code: string;
  flag: string;
}

interface Props {
  name?: string;
  value?: any;
  error?: string;
  disabled?: boolean;
  selectRef: React.RefObject<HTMLDivElement>;
  countryCodes: CountryCode[];
  onChange?: (value: any) => void;
  onSetValue?: (value: any) => string;
  onSetFieldValue?: (value: any) => any;
  formik?: FormikHelpers<string>;
}

const CountryCodeSelect = ({
  name,
  value,
  disabled,
  countryCodes,
  onChange,
  onSetValue,
  onSetFieldValue,
  formik,
  selectRef,
}: Props) => {
  const [showOptions, setShowOptions] = useState(false);
  const newValue = value?.name !== (null || undefined) ? value.name : value;

  const handleClick = () => {
    if (!disabled) {
      setShowOptions(!showOptions);
    }
  };

  const handleOptionsClose = () => {
    setShowOptions(false);
    if (name && formik) {
      formik.setFieldTouched(name);
    }
  };

  const handleChange = async (v: any) => {
    if (name && formik) {
      await formik.setFieldValue(name, onSetFieldValue ? onSetFieldValue(v) : v);
      formik.setFieldTouched(name);
    } else if (onChange) {
      onChange(v);
    }
  };

  return (
    <Container ref={selectRef}>
      <InputArea onClick={handleClick}>
        <Flag src={value.flag} alt="flag" />
        <Code>{onSetValue ? onSetValue(value) : newValue}</Code>
        <Arrow />
      </InputArea>
      <CountryCodeOptions
        selectRef={selectRef}
        show={showOptions}
        value={value}
        onClose={handleOptionsClose}
        onChange={handleChange}
        countries={countryCodes}
      />
    </Container>
  );
};

export default CountryCodeSelect;
